var formId = document.querySelector('.product form.form[action="/cart/add"]').getAttribute('id');
// open box 
function openCtzBox(){
  document.querySelector('.customize-box-wrapper').style.display = 'block';
  setTimeout(()=>{
    document.querySelector('.customize-box-wrapper').classList.add('its-on');
  },50);
  ctzClickEvents();
}

// close box 
function closeCtzBox(){
  document.querySelector('.customize-box-wrapper').classList.remove('its-on');
  setTimeout(()=>{
    document.querySelector('.customize-box-wrapper').style.display = 'none';
  },150);
  ctzClickEvents();
}

// box tab
document.querySelectorAll('.ctz-tab-title').forEach((ele)=>{
  ele.addEventListener('click',function(){
    let i = this.dataset.index;
    document.querySelectorAll('.customize-box-tab-cotent').forEach(function(ele,i){
      ele.classList.remove('active-tab-con');
      i = i+1;
      if(document.querySelector('.ctz-tab-title[data-index="'+i+'"]')){
        document.querySelector('.ctz-tab-title[data-index="'+i+'"]').classList.remove('active-tab');
      }
    });
    this.classList.add('active-tab');
    document.querySelector('.customize-box-tab-cotent[data-index="'+i+'"]').classList.add('active-tab-con');
  })
});

// swap open
document.querySelectorAll('.ctz-swap-item-name').forEach((ele)=>{
  ele.addEventListener('click',function(){
    document.querySelectorAll('.ctz-swap-item-name').forEach((ele)=>{
      ele.style.display = 'flex'; 
      
    });
     this.style.display = 'none';
  })
});

// swap change 
document.querySelectorAll('button.ctz-swap-btn').forEach((ele)=>{
  ele.addEventListener('click',function(){
    let select = this.closest('.ctz-swap-select-main').querySelector('select.ctz-swap-select');
    if(select.value != select.dataset.value){
      let selName = select.options[select.selectedIndex].text;
      this.closest('.ctz-swap-item-main').querySelector('.ctz-swap-item-title').textContent = selName;
      if(select.value != select.dataset.old){
        this.closest('.ctz-swap-item-main').classList.add('its-swap');
      }else{
        this.closest('.ctz-swap-item-main').classList.remove('its-swap');
      }
      select.setAttribute('data-value',select.value);
    }
    document.querySelectorAll('.ctz-swap-item-name').forEach((ele)=>{
      ele.style.display = 'flex'; 
    });
  });
});

// reset all swap
function resetAllSwap(){
  document.querySelectorAll('.ctz-swap-item-main.its-swap').forEach((ele)=>{
    let sel = ele.querySelector('select.ctz-swap-select')
    let oldVal = sel.dataset.old;
    sel.value = oldVal;
    ele.querySelector('.ctz-swap-btn').dispatchEvent(new Event('click'));
  });
}

// packing option
function packOpt() {
  let pO = document.querySelector('.customize-box-tab-cotent[data-index="3"] select.ctz-packing-select').value,
    sR = document.querySelector('.customize-box-tab-cotent[data-index="3"] .ctz-packing-req-main textarea').value
    $('.product form.form[action="/cart/add"]').append(`<input type="hidden" value="${pO}" name="properties[Pack my beef in]" form="${formId}">`);
    if(sR != ''){
      $('.product form.form[action="/cart/add"]').append(`<input type="hidden" value="${sR}" name="properties[Packing request]" form="${formId}">`);
    }else{
      $('[name="properties[Packing request]"]').remove();
    }
}
packOpt();

// save customize box
function saveCustomizeBox() {
  document.querySelectorAll('.ctz-swap-item-main').forEach((ele)=>{
      let i = ele.dataset.index,
      sel = ele.querySelector('select.ctz-swap-select'),
      selVal = sel.value,
      selText = sel.options[sel.selectedIndex].text,
      selId = sel.options[sel.selectedIndex].dataset.id,
      inHtml = ele.querySelector('.ctz-swap-item-name').innerHTML;
      if(ele.classList.contains('its-swap')){
        document.querySelector('.inside-product-details[data-index="'+i+'"]>span').innerHTML = inHtml;
        document.querySelector('.inside-product-details[data-index="'+i+'"]>input.swap-item-input').value = selText;
        document.querySelector('.inside-product-details[data-index="'+i+'"]>input.swap-item-input').setAttribute('data-id',selId);
      }else{
        document.querySelector('.inside-product-details[data-index="'+i+'"]>span').innerHTML = selText;
        document.querySelector('.inside-product-details[data-index="'+i+'"]>input.swap-item-input').value = selText;
        document.querySelector('.inside-product-details[data-index="'+i+'"]>input.swap-item-input').setAttribute('data-id',selId);
      }
      document.querySelector('.inside-product-details[data-index="'+i+'"]').setAttribute('data-id',selVal);
  });
  let index = 0;
  document.querySelectorAll('.ctz-tab-beef-up-item-main quantity-input.quantity').forEach((ele)=>{
    if(ele.querySelector('.quantity__input').value > 0){
      index = index+1;
      let i = ele.closest('.ctz-tab-beef-up-item-main').dataset.index,
      id = ele.dataset.id,
      qty = ele.querySelector('.quantity__input').value,
      price = ele.dataset.price,
      itemTitle = ele.closest('.ctz-tab-beef-up-item-main').querySelector('span.ctz-tab-beef-item-title>span').textContent;
      let itemHtml = `<div class="inside-plus-product-details get-item" data-index="${i}" data-id="${id}" data-qty="${qty}" data-price="${price}">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
                            <path stroke="#bf955a" d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/></path>
                            <path stroke="#bf955a" d="M22 4 12 14.01l-3-3"/></path>
                          </svg>
                          <span class="plus-item-title">${itemTitle}</span>
                          <span class="plus-item-qty">x${qty}</span>
                          <span class="plus-item-remove" data-remove="${i}">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x ctz-close" id="svg164168718_225">
                              <path d="M18 6 6 18M6 6l12 12" stroke="#bf955a" fill="none" stroke-width="2px"></path>
                            </svg>
                          </span>
                        </div>`;
    itemHtml = new DOMParser().parseFromString(itemHtml, 'text/html').querySelector('.inside-plus-product-details');
    if(document.querySelector('.inside-plus-products .inside-plus-product-details[data-index="'+i+'"]')){
      document.querySelector('.inside-plus-products .inside-plus-product-details[data-index="'+i+'"]').remove();
    }
    document.querySelector('.inside-plus-products').appendChild(itemHtml);
    document.querySelector('.inside-plus-main').style.display = 'block';
    }
  });
  packOpt();
  addPrice();
  document.body.classList.remove('swap-alert');
  closeCtzBox();
}


// add price in product
function addPrice() {  
  let addPrice = getAllPrice(),
   pPrice = document.querySelector('.product__info-container [data-main-price]').dataset.mainPrice,
   tPrice = Number(addPrice)+Number(pPrice),
   itemPrice = moneyFormate(tPrice),
   emiPrice = tPrice/100;
   if(document.querySelector('[data-zm-price]')){
     document.querySelector('[data-zm-price]').setAttribute('data-zm-price',emiPrice);
   }
   document.querySelector('square-placement[data-amount]').setAttribute('data-amount',emiPrice);
   document.querySelector('.product__info-container .price__regular .price-item--regular').textContent = itemPrice;
}
 

// get plus item price
function getAllPrice() {
  let allPrice = 0;
  document.querySelectorAll('.inside-plus-product-details').forEach((ele)=>{
    let price = ele.dataset.price,
    qty = ele.dataset.qty;
    price = price*qty;
    allPrice = Number(price)+Number(allPrice);
  });
  return allPrice;
}

// remove swap 
function removeSwap(i,oId) {
  let sel = document.querySelector('.ctz-swap-item-main.its-swap[data-index="'+i+'"]').querySelector('.ctz-swap-select');
  sel.value = oId;
  sel.dispatchEvent(new Event('change'));
  let selText = sel.options[sel.selectedIndex].text,selVal = sel.value;
  document.querySelector('.ctz-swap-item-main.its-swap[data-index="'+i+'"]').querySelector('.ctz-swap-item-title').textContent = selText;
  document.querySelector('.inside-product-details[data-index="'+i+'"]>span').innerHTML = selText;
  document.querySelector('.inside-product-details[data-index="'+i+'"]>input.swap-item-input').value = selText;
  document.querySelector('.inside-product-details[data-index="'+i+'"]').setAttribute('data-id',selVal);
  sel.setAttribute('data-value',selVal);
  document.querySelector('.ctz-swap-item-main.its-swap[data-index="'+i+'"]').classList.remove('its-swap');
}

// add alert;
document.querySelectorAll('.ctz-tab-beef-up-item-main quantity-input.quantity').forEach((ele)=>{
  ele.addEventListener('change',function(){
    document.body.classList.add('swap-alert');
  });
});
document.querySelectorAll('select.ctz-swap-select').forEach((ele)=>{
  ele.addEventListener('change',function(){
    document.body.classList.add('swap-alert');
  });
});
document.querySelectorAll('select.ctz-packing-select').forEach((ele)=>{
  ele.addEventListener('change',function(){
    document.body.classList.add('swap-alert');
  });
});
document.querySelectorAll('.ctz-packing-req-main textarea').forEach((ele)=>{
  ele.addEventListener('change',function(){
    document.body.classList.add('swap-alert');
  });
});



// alert text
function saveAlert() {
  if(document.body.classList.contains('swap-alert')){
    alert('There are unsaved changes. Ensure that you have save your changes before proceeding.');
  }
}

// remove beef up
function removeBeefUp(i) {
  document.querySelector('.inside-plus-products .inside-plus-product-details[data-index="'+i+'"]').remove();
  document.querySelector('.ctz-tab-beef-up-item-main[data-index="'+i+'"] .quantity__input').value = 0;
  if(document.querySelectorAll('.inside-plus-products .inside-plus-product-details').length == 0){
    document.querySelector('.inside-plus-main').style.display = 'none';
  }
  addPrice();
  ctzClickEvents();
}

// click events
$(document).mouseup(function(e) {
  var container = $('.customize-box-main');
  if (!container.is(e.target) && container.has(e.target).length === 0 && document.querySelector('.customize-box-wrapper').style.display == 'block'){
    document.querySelector('.customize-box-main svg.ctz-close').dispatchEvent(new Event('click'));
  }
});
document.querySelector('button#ctz-save-button').addEventListener('click',function(){
  saveCustomizeBox();
});
document.querySelector('.customize-box-main svg.ctz-close').addEventListener('click',function(){
  saveAlert();
  closeCtzBox();
});
function ctzClickEvents() {
  if(document.querySelector('button#customize-button')){
    document.querySelector('button#customize-button').addEventListener('click',function(){
      openCtzBox();
    });
  }
  document.querySelector('span#ctz-reset').addEventListener('click',function(){
    resetAllSwap();
  });
  document.querySelectorAll('.inside-product-details>span svg').forEach((ele)=>{
    ele.addEventListener('click',function(){
      let i = this.closest('.inside-product-details').dataset.index,
        oId = this.closest('.inside-product-details').dataset.oldId;
      removeSwap(i,oId);
    });
  });
  if(document.querySelector('span.plus-item-remove')){
    document.querySelector('span.plus-item-remove').addEventListener('click',function(){
      let i = this.closest('.inside-plus-product-details').dataset.index;
      removeBeefUp(i);
    });
  }
}
ctzClickEvents();